const getScoreAsPercentage = (achieved, achievable) => {
    if (achievable === 0)
        return 0;
    return Math.round((achieved / achievable) * 100);
};
const getMessageForPercentage = (percentage, veryGoodMessage, wellDoneMessage, badMessage) => {
    if (percentage > 66)
        return veryGoodMessage;
    if (percentage > 33)
        return wellDoneMessage;
    return badMessage;
};

export { getMessageForPercentage, getScoreAsPercentage };
